import { useAppStore } from '@/stores/app';

export default defineNuxtRouteMiddleware(async () => {
  const appStore = useAppStore();

  if (!appStore.initialized) {
    await appStore.initShell();
  }
});
